<template>
    <v-layout
        row
        wrap
        align-left
    >
        <v-flex>
            <v-container class="t_create_edit_dialog">
                <h1
                    v-if="$route.params.id == null"
                    class="bolded"
                >
                    {{ $t('administration.domain.manage.add.title') }}
                </h1>
                <v-form
                    ref="formDomain"
                    v-model="valid"
                    class="form-style"
                    lazy-validation
                >
                    <v-layout
                        column
                        justify-center
                    >
                        <v-flex md6>
                            <v-text-field
                                v-model="domain.label"
                                class="t_name"
                                :label="$t('administration.domain.label.name')"
                                :rules="labelRules"
                                required
                                clearable
                            />
                        </v-flex>
                        <v-flex md6>
                            <v-text-field
                                v-model="domain.code"
                                class="t_abbreviation"
                                :label="$t('administration.domain.label.abbreviation')"
                                :rules="abbreviationRules"
                                required
                                clearable
                            />
                        </v-flex>
                        <v-flex md6>
                            <v-text-field
                                v-model="domain.description"
                                class="t_description"
                                :label="$t('administration.domain.label.description')"
                                :rules="labelRules"
                                required
                                clearable
                            />
                        </v-flex>
                        <!-- ADDITIONAL WORKSPACES -->
                        <v-autocomplete
                            v-model="domain.basicWorkspaceList"
                            :items="allWorkspaceList"
                            class="t_workspaces"
                            :disabled="allWorkspaceList.length === 0"
                            dense
                            filled
                            multiple
                            chips
                            small-chips
                            item-text="name"
                            return-object
                            label="Workspaces"
                        />
                        <!-- MARKET -->
                        <v-autocomplete
                            v-model="domain.markets"
                            class="t_markets"
                            :disabled="allMarketList.length === 0"
                            :items="allMarketList"
                            dense
                            filled
                            multiple
                            chips
                            small-chips
                            item-text="code"
                            return-object
                            label="Markets"
                        />
                        <!-- BUTTONS -->
                        <v-flex
                            xs3
                            justify-end
                        >
                            <v-tooltip
                                top
                                class="align-action-end"
                            >
                                <v-btn
                                    slot="activator"
                                    color="#355B7F"
                                    small
                                    fab
                                    :to="{ name: 'DomainSearch' }"
                                >
                                    <v-icon color="white">
                                        cancel
                                    </v-icon>
                                </v-btn>
                                <span>{{ $t("administration.domain.manage.action.cancel") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                v-if="valid"
                                top
                                class="align-action-end"
                            >
                                <v-btn
                                    slot="activator"
                                    class="t_save"
                                    color="primary"
                                    small
                                    fab
                                    dark
                                    icon
                                    @click="manage(domain)"
                                >
                                    <v-icon>save</v-icon>
                                </v-btn>
                                <span>{{ $t("administration.domain.manage.action.add") }}</span>
                            </v-tooltip>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-container>
        </v-flex>
    </v-layout>
</template>

<script>
import axios            from 'axios';
import EventBus         from '../../../utils/event-bus.js';
import ConstantEvent    from '../../../shared/constant/constantEvent.js'

export default {
    name: "DomainManagement",
    props: {
        idDocument: Number,
        datasheet: Object
    },
    data() {
        return {
            valid: false,
            domain: {
                id: null,
                label: null,
                description: null,
                code: null,
                basicWorkspaceList: [],
                markets: []
            },
            allWorkspaceList: [],
            allMarketList: [],
            labelRules: [
                v => !!v || this.$t("administration.domain.manage.required")
            ],
            abbreviationRules: [
                v => !!v || this.$t("administration.domain.manage.required"),
                v => !!v && v.length < 6 || this.$t("administration.domain.manage.too-long") + "5"
            ]
        }
    },
    mounted() {
        /**
             * When the page is charging, we pay attention if an id is passed,
             * if it's the case, it means that we update a domain instead of creating one
             */
        if (this.$route.params.id !== undefined) {
            this.loadDomain(this.$route.params.id);
        }
        this.loadWorkspacesAndMarkets();
    },
    methods: {
        /**
             *  Create or update a domain
             * @param newDomain
             */
        manage(domain) {
            if (this.$refs.formDomain.validate()) {
                var method = null;
                if (!!this.$route.params.id) {
                    method = "PUT",
                    domain.id = this.$route.params.id;
                } else {
                    method = "POST";
                }
                axios({
                    method: method,
                    url: "administration/domain",
                    data: domain
                }).then(() => {
                    EventBus.$emit(ConstantEvent.ADD_NOTIFICATION, {
                        message: 'administration.domain.manage.' + (!this.$route.params.id ? 'add' : 'edit') + '.success',
                        type: 'SUCCEED'
                    }
                    );
                    this.$router.push('/administration/domain');
                });
            }
        },
        /**
             * Retrieve a domain with its id
             * @param id
             */
        loadDomain(id) {
            axios.get(
                `administration/domain/${id}`
            ).then(result => {
                this.domain = result.data;
            });
        },
        loadWorkspacesAndMarkets() {
            axios.get(
                `administration/workspace/filterAll`
            ).then(result => {
                this.allWorkspaceList = result.data;
                return axios.get(
                    `administration/markets`
                );
            }).then(result => {
                this.allMarketList = result.data;
            });
        },
    }
}
</script>
<style scoped>
    .form-style {
        margin-top: 50px;
    }

    .align-action-end {
        float: right;
    }

    .bolded {
        font-weight: bold;
        color: #355B7F;
    }
</style>
